import * as Models from "@gigalot/data-models";

export const formatDoseLabel = (dose: Models.Dose): string => {
  const amount = dose.amount !== undefined ? dose.amount : "";
  const unit = dose.unit || "cc";
  if (dose.type === "cc-mass-dependent") {
    const kgPerDose = dose.kgPerDose !== undefined ? dose.kgPerDose : "?";
    if (unit === "each") {
      return `${amount} per ${kgPerDose} kg`;
    }
    return `${amount} ${unit} per ${kgPerDose} kg`;
  }
  return `${amount} ${unit}`;
};
